module.exports = __webpack_public_path__ + "img/Freesia1.ea41bdfb.jpg";